'use strict';

var ConfigurationFareBuilderDirective = function ConfigurationFareBuilderDirective() {
  return {
    restrict: 'E',
    controller: 'ConfigurationFareBuilderController',
    template: require('../templates/configuration-fare-builder.html'),
    link: function link($scope, element) {
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
    }
  };
};
ConfigurationFareBuilderDirective.$inject = [];
module.exports = ConfigurationFareBuilderDirective;